import { Directive, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[scroll]",
})
export class ScrollDirective {
  _cHead;

  @Input("cHead") set cHead(cHeadElement: any) {
    this._cHead = cHeadElement;
  }

  @HostListener("scroll", ["$event"])
  onScroll(event) {
    if (this._cHead && this._cHead.nativeElement && event && event.target) {
      this._cHead.nativeElement.scrollLeft = event.target.scrollLeft;
    }
  }

  constructor() {}
}
